<div
    *ngIf="settingsData.phoneEmailTopToggle"
    class="phone-email-switcher">
    <mat-radio-group
        aria-label="Select an option"
        class="d-flex">
        <mat-radio-button
            value="0"
            [checked]="showUserPhones"
            (click)="setShowUserPhones()">
            By Phone Number
        </mat-radio-button>
        <mat-radio-button
            value="1"
            [checked]="showUserEmail"
            (click)="setShowUserEmail()">
            By Email
        </mat-radio-button>
    </mat-radio-group>
</div>
<div
    class="type-selector-holder"
    *ngIf="showTypeSelector">
    <ng-select
        [(ngModel)]="selectedUserType"
        [ngModelOptions]="{ standalone: true }"
        [clearable]="false"
        [searchable]="false"
        placeholder="Select user type"
        (ngModelChange)="filterUsers()">
        <ng-option
            *ngFor="let userType of userTypes"
            [value]="userType.id">
            {{ userType.name }}
        </ng-option>
    </ng-select>
</div>
<div class="new-chat-dlg-top">
    <input
        type="text"
        class="search-text-input"
        placeholder="Search User by Name"
        [formControl]="searchName" />
</div>
<div
    *yssIsLoading="loading"
    class="new-chat-dlg-users styled-scrolled">
    <div
        class="chat-user"
        *ngFor="let user of filteredUsers"
        (click)="userSelected(user)">
        <div
            *ngIf="!allowToSelectMany && !settingsData.selectByClick"
            class="chat-user-rb-holder">
            <mat-radio-group
                aria-label="Select an option"
                class="d-flex">
                <mat-radio-button
                    value="user.id"
                    [checked]="selectedUserIds.includes(user.id)"
                    (click)="onRadioButtonClick(user, $event)">
                </mat-radio-button>
            </mat-radio-group>
        </div>
        <div
            *ngIf="allowToSelectMany && !settingsData.selectByClick"
            class="chat-user-cb-holder">
            <input
                type="checkbox"
                class="form-check-input checkbox-dark-styled"
                [checked]="selectedUserIds.includes(user.id)"
                (click)="onCheckBoxClick(user, $event)" />
        </div>
        <div
            class="chat-user-avater-holder"
            [style.width.px]="avatarSize"
            [style.height.px]="avatarSize"
            [style.min-width.px]="avatarSize">
            <app-avatar
                [user]="user"
                [fontSize]="'12px'"
                [fontWeight]="'600'"
                [showIcons]="true"
                [darkIcon]="true">
            </app-avatar>
        </div>
        <div class="chat-user-name-holder">
            <div class="chat-user-name">{{ user.contact.firstname }} {{ user.contact.surname }}</div>
            <div class="chat-user-type">
                {{ showUserPhones ? user.mobile : '' }}
                {{ showUserEmail ? user.email : '' }}
                {{
                    showCompnayName && (user.companyName || user.prospectCompanyName)
                        ? ' - ' + user.companyName || user.prospectCompanyName
                        : ''
                }}
            </div>
        </div>
    </div>
</div>
<div
    *ngIf="!settingsData.selectByClick"
    class="new-chat-dlg-bottom">
    <button
        class="btn btn-styled--secondary btn-block btn-select"
        type="button"
        mat-dialog-close
        [disabled]="false"
        (click)="cancel()">
        Cancel
    </button>
    <button
        class="btn btn-styled btn-block btn-select mx-2"
        type="button"
        [disabled]="selectedUserIds.length === 0"
        (click)="selectUsers()">
        {{ buttonLabel }}
    </button>
</div>
<div
    *ngIf="settingsData.showCreateLeadBtn"
    class="add-new-btn-holder">
    <button
        type="button"
        class="btn-styled"
        (click)="addNewLead.emit()">
        Add New
        <svg-icon
            src="assets/images/buttons/plus-icon.svg"
            [class]="'--suffix'"
            [svgClass]="'icon--button'"></svg-icon>
    </button>
</div>
